var React = require('react');

function Phone (props) {
    return React.createElement("svg",props,[React.createElement("path",{"stroke":"#FFCB00","strokeWidth":"2","d":"M4.74 10c0-3.771 0-5.657 1.172-6.828C7.083 2 8.969 2 12.74 2c3.772 0 5.657 0 6.829 1.172C20.74 4.343 20.74 6.229 20.74 10v4c0 3.771 0 5.657-1.171 6.828C18.397 22 16.512 22 12.74 22c-3.771 0-5.657 0-6.828-1.172C4.74 19.657 4.74 17.771 4.74 14v-4Z","key":0}),React.createElement("path",{"stroke":"#FFCB00","strokeLinecap":"round","strokeWidth":"2","d":"M15.74 19h-6","key":1})]);
}

Phone.defaultProps = {"width":"25","height":"24","fill":"none"};

module.exports = Phone;

Phone.default = Phone;
